export interface Sort {
  key: string,
  order: string,
}

export interface ApiArgs {
  limit?: Number
  offset?: Number
  sorts?: Sort[]
  filters?: Record<string, any>
}

export const buildApiUrl = (
  baseUrl: string,
  {
    limit = undefined,
    offset = undefined,
    sorts = [],
    filters = {},
  }: ApiArgs
) => {

  let output = baseUrl

  // compile queryVars

  const queryVars: Record<string, any> = {}

  if (limit !== null && limit !== undefined) {
    queryVars.limit = limit
  }

  if (offset !== null && offset !== undefined) {
    queryVars.offset = offset
  }

  if (sorts.length) {
    queryVars.sort = sorts[0].key
    queryVars.order = sorts[0].order
  }

  Object.entries(filters).forEach(([name, value]) => {

    let serializedValue = null

    if (value === null || value === undefined || value === '') {
      return
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        return
      }
      serializedValue = value.join(',')
    } else if (value === true || value === false) {
      serializedValue = value ? '1' : '0'
    } else {
      serializedValue = value
    }

    queryVars[name] = serializedValue

  })

  // build the querystring (if necessary)

  if (Object.keys(queryVars).length) {
    const queryPairs = Object.entries(queryVars).map(([varName, varValue]) => {
      return encodeURIComponent(varName) + '=' + encodeURIComponent(varValue)
    })
    output += '?' + queryPairs.join('&')
  }

  return output

}
